"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.worksCatalogue = exports.workRule = exports.updateStatus = exports.upExcelTem = exports.schoolSys = exports.schoolStageWorksList = exports.schoolProject = exports.schoolMove = exports.schoolList = exports.schoolEdit = exports.schoolAdd = exports.registrationList = exports.projectStage = exports.insetWorkList = exports.getWorksList = exports.getTeacherListByPartyInfoId = exports.getStudentListByPartyInfoId = exports.getScoolInfoById = exports.getPartyLogList = exports.exportWorkList = exports.exitStatus = exports.editSubmit = exports.delWorkList = void 0;
var _api = _interopRequireDefault(require("_l/api.request"));
var _qs = _interopRequireDefault(require("qs"));
/**
 * 描述 获取报名表操作记录列表
 * @author kkdy
 * @date 2021-11-23
 * @param {any} data
 * @returns {any}
 */
var getPartyLogList = exports.getPartyLogList = function getPartyLogList(data) {
  return _api.default.request({
    url: '/partyLog/getPartyLogList',
    method: 'post',
    data: _qs.default.stringify(data)
  });
};
/**
 * 描述 获取学校报名表退审接口
 * @author kkdy
 * @date 2021-11-23
 * @param {any} data
 * @returns {any}
 */
var exitStatus = exports.exitStatus = function exitStatus(data) {
  return _api.default.request({
    url: '/partyInfo/exitStatus',
    method: 'post',
    data: data
  });
};
/**
 * 描述 获取学校报名表审核接口
 * @author kkdy
 * @date 2021-11-23
 * @param {any} data
 * @returns {any}
 */
var updateStatus = exports.updateStatus = function updateStatus(data) {
  return _api.default.request({
    url: '/partyInfo/updateStatus',
    method: 'post',
    data: data
  });
};
/**
 * 描述 获取学校报名表教师列表
 * @author kkdy
 * @date 2021-11-23
 * @param {any} data
 * @returns {any}
 */
var getTeacherListByPartyInfoId = exports.getTeacherListByPartyInfoId = function getTeacherListByPartyInfoId(data) {
  return _api.default.request({
    url: '/partyInfo/getTeacherListByPartyInfoId',
    method: 'post',
    data: _qs.default.stringify(data)
  });
};
/**
 * 描述 获取学校报名表学生列表
 * @author kkdy
 * @date 2021-11-23
 * @param {any} data
 * @returns {any}
 */
var getStudentListByPartyInfoId = exports.getStudentListByPartyInfoId = function getStudentListByPartyInfoId(data) {
  return _api.default.request({
    url: '/partyInfo/getStudentListByPartyInfoId',
    method: 'post',
    data: _qs.default.stringify(data)
  });
};
/**
 * 描述 获取学校报名表列表
 * @author kkdy
 * @date 2021-11-23
 * @param {any} data
 * @returns {any}
 */
var registrationList = exports.registrationList = function registrationList(data) {
  return _api.default.request({
    url: '/partyInfo/getList',
    method: 'post',
    data: data
  });
};
/**
 * 描述 获取学校列表
 * @author kkdy
 * @date 2021-11-23
 * @param {any} data
 * @returns {any}
 */
var schoolList = exports.schoolList = function schoolList(data) {
  return _api.default.request({
    url: '/school/schoolList',
    method: 'post',
    data: data
  });
};
/**
 * 描述 新增学校
 * @author kkdy
 * @date 2021-11-23
 * @param {any} data
 * @returns {any}
 */
var schoolAdd = exports.schoolAdd = function schoolAdd(data) {
  return _api.default.request({
    url: '/school/saveSchool',
    method: 'post',
    data: data
  });
};
/**
 * 描述 获取学校信息回显
 * @author kkdy
 * @date 2022-01-06
 * @param {any} data
 * @returns {any}
 */
var getScoolInfoById = exports.getScoolInfoById = function getScoolInfoById(data) {
  return _api.default.request({
    url: '/school/oneSchool',
    method: 'post',
    data: data
  });
};
/**
 * 描述 删除学校
 * @author kkdy
 * @date 2021-11-23
 * @param {any} data
 * @returns {any}
 */
var schoolMove = exports.schoolMove = function schoolMove(data) {
  return _api.default.request({
    url: '/school/removeSchool',
    method: 'post',
    data: data
  });
};
/**
 * 描述 编辑学校
 * @author kkdy
 * @date 2021-11-23
 * @param {any} data
 * @returns {any}
 */
var schoolEdit = exports.schoolEdit = function schoolEdit(data) {
  return _api.default.request({
    url: '/school/editSchool',
    method: 'post',
    data: data
  });
};
/**
 * 描述
 * @author kkdy
 * @date 2021-12-11
 * @param {any} data
 * @returns {any}
 */
var schoolSys = exports.schoolSys = function schoolSys(data) {
  return _api.default.request({
    url: '/school/getSchoolAdmins',
    method: 'post',
    data: data
  });
};
/**
 * 描述 获取学校下的项目列表
 * @author kkdy
 * @date 2021-12-11
 * @param {any} data
 * @returns {any}
 */
var schoolProject = exports.schoolProject = function schoolProject(data) {
  return _api.default.request({
    url: 'matchWorks/getMatchListForSchool',
    method: 'post',
    data: data
  });
};
/**
 * 描述 获取学校阶段项目列表
 * @author kkdy
 * @date 2021-12-11
 * @param {any} data
 * @returns {any}
 */
var projectStage = exports.projectStage = function projectStage(data) {
  return _api.default.request({
    url: '/matchWorks/getMatchGroupStageList',
    method: 'post',
    data: data
  });
};
/**
 * 描述 学校管理员下项目阶段下的作品列表
 * @author kkdy
 * @date 2021-12-11
 * @param {any} data
 * @returns {any}
 */
var schoolStageWorksList = exports.schoolStageWorksList = function schoolStageWorksList(data) {
  return _api.default.request({
    url: '/matchWorks/getSchoolPlayerWorkList',
    method: 'post',
    data: data
  });
};
/**
 * 描述 获取作品清单规则
 * @author kkdy
 * @date 2021-12-30
 * @param {any} data
 * @returns {any}
 */
var worksCatalogue = exports.worksCatalogue = function worksCatalogue(data) {
  return _api.default.request({
    url: '/matchWorkFormFile/getWorkFormRuleList',
    method: 'post',
    data: _qs.default.stringify(data)
  });
};
/**
 * 描述 新增时获取清单详情
 * @author kkdy
 * @date 2021-12-31
 * @param {any} data
 * @returns {any}
 */
var workRule = exports.workRule = function workRule(data) {
  return _api.default.request({
    url: '/matchWorkFormFile/getWorkFormFileDetail',
    method: 'post',
    data: _qs.default.stringify(data)
  });
};
/**
 * 描述 新增作品清单详情
 * @author kkdy
 * @date 2021-12-31
 * @param {any} data
 * @returns {any}
 */
var insetWorkList = exports.insetWorkList = function insetWorkList(data) {
  return _api.default.request({
    url: '/matchWorkFormFile/insertWorkFormFile',
    method: 'post',
    data: data
  });
};
/**
 * 描述 获取作品列表
 * @author kkdy
 * @date 2021-12-31
 * @param {any} data
 * @returns {any}
 */
var getWorksList = exports.getWorksList = function getWorksList(data) {
  return _api.default.request({
    url: '/matchWorkFormFile/getListWorkFormFileList',
    method: 'post',
    data: data
  });
};
/**
 * 描述 删除某条作品清单
 * @author kkdy
 * @date 2021-12-31
 * @param {any} data
 * @returns {any}
 */
var delWorkList = exports.delWorkList = function delWorkList(data) {
  return _api.default.request({
    url: '/matchWorkFormFile/deleteFormFileByIds',
    method: 'post',
    data: data
  });
};
/**
 * 描述 编辑作品清单后提交
 * @author kkdy
 * @date 2021-12-31
 * @param {any} data
 * @returns {any}
 */
var editSubmit = exports.editSubmit = function editSubmit(data) {
  return _api.default.request({
    url: '/matchWorkFormFile/editWorkFormFile',
    method: 'post',
    data: data
  });
};
/**
 * 描述 作品清单导出
 * @author kkdy
 * @date 2021-12-31
 * @param {any} data
 * @returns {any}
 */
var exportWorkList = exports.exportWorkList = function exportWorkList(data) {
  return _api.default.request({
    url: '/matchWorkFormFile/workFormListExport',
    method: 'post',
    data: _qs.default.stringify(data),
    responseType: 'blob'
  });
};
/**
 * 描述 学校信息导入模板
 * @author kkdy
 * @date 2022-01-07
 * @param {any} data
 * @returns {any}
 */
var upExcelTem = exports.upExcelTem = function upExcelTem(data) {
  return _api.default.request({
    url: '/school/import',
    method: 'post',
    data: data,
    headers: {
      'content-type': 'multipart/form-data'
    }
    // responseType: 'blob'
  });
};